import { render, staticRenderFns } from "./ConfirmRenewalPage.vue?vue&type=template&id=232615e2&scoped=true"
import script from "./ConfirmRenewalPage.vue?vue&type=script&lang=js"
export * from "./ConfirmRenewalPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRenewalPage.vue?vue&type=style&index=0&id=232615e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232615e2",
  null
  
)

export default component.exports